import { EnrollmentRepository } from '@/application/shared/domain/EnrollmentRepository';
import { UseCase } from '@/shared/application/UseCase';
import { SfApiResponse } from '@hfc/ui-core';
import { FeedbackInfo } from '@/application/shared/domain/FeedbackInfo';

export class SendAnonymousFeedbackUseCase implements UseCase<FeedbackInfo, SfApiResponse> {

  private repository: EnrollmentRepository;

  public constructor (repository: EnrollmentRepository) {
    this.repository = repository;
  }

  public async run (feedbackInfo: FeedbackInfo): Promise<SfApiResponse> {
    return await this.repository.sendAnonymousFeedback(feedbackInfo);
  }

}
